import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormField } from "@shared/services/FormServices";
import { BUTTON_FIELD_CLASSES } from "@shared/utils/constants";
import { useGetChoices } from "@features/ix/hooks";

interface SyncActivityFilterProps {
  form: UseFormReturn<any>;
  onApply: (data: any) => void;
  onReset: () => void;
}

export const SyncActivityFilter: React.FC<SyncActivityFilterProps> = ({
  form,
  onApply,
  onReset,
}) => {
  const { data: syncLogStatusData } = useGetChoices("sync_log_status");
  const { data: syncLogFlowData } = useGetChoices("sync_log_flow");
  const { data: syncLogPeriodData } = useGetChoices("sync_log_period");
  const fields: FormField[] = [
    {
      name: "flow",
      label: "Flow Type",
      type: "select",
      placeholder: "All flows",
      options: syncLogFlowData?.map((d: any) => ({
        value: d.key,
        label: d.value,
      })),
    },
    {
      name: "status",
      label: "Sync Status",
      type: "select",
      placeholder: "All statuses",
      options: syncLogStatusData?.map((d: any) => ({
        value: d.key,
        label: d.value,
      })),
    },
    {
      name: "dateRange",
      label: "Time Range",
      type: "select",
      placeholder: "Last 24 hours",
      options: syncLogPeriodData?.map((d: any) => ({
        value: d.key,
        label: d.value,
      })),
    },
  ];

  const handleReset = () => {
    form.reset({
      flow: "",
      status: "",
      dateRange: "",
    });
    onReset();
  };

  return (
    <div className="space-y-4">
      <DynamicForm
        fields={fields}
        form={form}
        gridColumns={3}
        responsiveColumns={{ sm: 1, md: 2, lg: 3 }}
        onSubmit={onApply}
        onReset={handleReset}
        config={{
          showResetButton: true,
          resetButtonText: "Reset",
          submitButtonText: "Apply Filters",
          classes: BUTTON_FIELD_CLASSES,
        }}
      />
    </div>
  );
};

export default SyncActivityFilter;
